import React from 'react';
import classNames from 'classnames';
import DocumentLink from './DocumentLink';
import { formatDateTime } from '../../../utils/date-utils';

const DocumentAttachments = ({ documentId, attachments }) => (
  <div className="col3">
    {attachments.map((attachment) => {
      const isNew = attachment.isNew;
      const isUpdated = attachment.isUpdated;
      let title = '';
      if (isNew) {
        title = `Créé le ${formatDateTime(attachment.audit.creationDateTime)}`;
      } else if (isUpdated) {
        title = `Mise à jour le ${formatDateTime(attachment.audit.updateDateTime)}`;
      }
      return (
        <DocumentLink
          key={attachment.id}
          external={attachment.type === 'LINK'}
          to={attachment.type === 'LINK' ? attachment.fileName : `/documents/${documentId}/${attachment.id}`}
          onClick={e => e.stopPropagation()}
          className={classNames(
            'btn',
            isNew || isUpdated ? 'btn-rose' : 'btn-vert',
            { 'btn-disabled': attachment.loading }
          )}
          disabled={attachment.loading}
          title={title}
        >
          {isNew && (
            <span className="label label-rose-inverted">New</span>
          )}
          {isUpdated && (
            <span className="ic ic-lap ic-xs"/>
          )}
          {attachment.title}
        </DocumentLink>
      );
    })}
  </div>
);

export default DocumentAttachments;



// WEBPACK FOOTER //
// ./book/src/commons/components/document/table/DocumentAttachments.jsx